import axios from 'axios';
import Forms from '../common/forms';

export default class PedidosHits {
    constructor() {

        console.log('Carrega Script Plano Hits')

        this.x = -1;
        this.y = 7;
        this.hasCupom = false;
        this.tmp = 0;
        this.tpr = 0;

        this.section = document.querySelector('.modulo-pedidos_plano_hits')
        this.form = this.section.querySelector('form')
        this.buttonSubmit = this.form.querySelector('button[type="submit"]')
        
        Forms.maskField()
        this.ready();
        this.carregaDadosCep();
        
        this.btnOpenModalTerms = this.section.querySelector('.btn-open-modal-termos')
        this.modalTerms = this.section.querySelector('.modal-termos')
        this.controlModalTerms()
    }

    ready() {

        //Disable form button submit
        this.buttonSubmit.disabled = true

        //Action Apply coupon
        this.form.querySelector('.btnAplicarCupom').addEventListener('click', () => {
            this.coupon()
        })

        //Action change field number of stores
        this.form.querySelector('#qtde_lojas').addEventListener('change', (e) => {
            if(+this.form.querySelector('#qtde_lojas').value < 1 || +this.form.querySelector('#qtde_lojas').value > 10) {
                this.form.querySelector('.estabelecimentos-error').classList.remove('noShow')
            } else {
                this.form.querySelector('.estabelecimentos-error').classList.add('noShow')
                // this.addStore();
                this.calcPrices()
            }
            this.addStore();
        });

        //Action change field store sizes
        this.form.querySelector('#metragem').addEventListener('change', () => this.calcPrices());
        const inputsVinhetasExclusivas = this.form.querySelectorAll('input[name=vinhetas]')
        inputsVinhetasExclusivas.forEach((radio) => {
            radio.addEventListener('change', () => this.calcPrices());
        })

        //Action change field type of payment
        this.form.querySelector('#forma_pagamento').addEventListener('change', () => this.creditCardFields())
        
    }

    addStore() {

        const filiaisContainer = this.form.querySelector('#filiaisContainer')
        filiaisContainer.innerHTML = ''

        if(+this.form.querySelector('#qtde_lojas').value > 1) {
            for (let i = 1; i < +this.form.querySelector('#qtde_lojas').value; i++) {
                filiaisContainer.insertAdjacentHTML('beforeend', this.templateFiliais(i))
            }
        }

        Forms.maskField()
        this.carregaDadosCep()

    }

    calcPrices(e) {

        document.querySelector('.cupom-error').innerHTML = ''
        document.querySelector('.cupom-error').classList.add('noShow')

        // prices configuration here - HITS preços 2023
        let prcs = new Array();
        prcs[0] = [69.90, 94.37, 118.83, 143.30, 174.75, 216.69, 258.63, 300.57, 342.51, 384.45, 426.39];//ok
        prcs[1] = [67.10, 90.59, 114.08, 137.56, 167.76, 208.02, 248.28, 288.55, 328.81, 369.07, 409.33];//ok
        prcs[2] = [64.31, 86.82, 109.32, 131.83, 160.77, 199.35, 237.94, 276.52, 315.11, 353.69, 392.28];//ok
        prcs[3] = [61.51, 83.04, 104.57, 126.10, 153.78, 190.69, 227.59, 264.50, 301.41, 338.32, 375.22];//ok
        prcs[4] = [58.72, 79.27, 99.82, 120.37, 146.79, 182.02, 217.25, 252.48, 287.71, 322.94, 358.17];//ok
        prcs[5] = [55.92, 75.49, 95.06, 114.64, 139.80, 173.35, 206.90, 240.46, 274.01, 307.56, 341.11];//ok
        prcs[6] = [53.12, 71.72, 90.31, 108.90, 132.81, 164.68, 196.56, 228.43, 260.31, 292.18, 324.06];//ok
        prcs[7] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

        // prices configuration here - ECAD preços 2023
        let prcs2 = new Array();
        prcs2[0] = [139.00, 187.65, 236.30, 284.95, 347.50, 430.90, 514.30, 597.70, 681.10, 764.50, 847.90];//ok
        prcs2[1] = [133.44, 180.14, 226.85, 273.55, 333.60, 413.66, 493.73, 573.79, 653.86, 733.92, 813.98];//ok
        prcs2[2] = [127.88, 172.64, 217.40, 262.15, 319.70, 396.43, 473.16, 549.88, 626.61, 703.34, 780.07];//ok
        prcs2[3] = [122.32, 165.13, 207.94, 250.76, 305.80, 379.19, 452.58, 525.98, 599.37, 672.76, 746.15];//ok
        prcs2[4] = [116.76, 157.63, 198.49, 239.36, 291.90, 361.96, 432.01, 502.07, 572.12, 642.18, 712.24];//ok
        prcs2[5] = [111.20, 150.12, 189.04, 227.96, 278.00, 344.72, 411.44, 478.16, 544.88, 611.60, 678.32];//ok
        prcs2[6] = [105.64, 142.61, 179.59, 216.56, 264.10, 327.48, 390.87, 454.25, 517.64, 581.02, 644.40];//ok
        prcs2[7] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

        const estabelecimentos = this.form.querySelector('#qtde_lojas').value;
        const areatotal = this.form.querySelector('#metragem');
        const vinhetaExclusiva = this.form.querySelector('input[name=vinhetas]:checked');
        
        const formadepagamento = this.form.querySelector('#forma_pagamento');
        const totalPriceStore = this.form.querySelector('#totalPriceStore');
        const totalPrice = this.form.querySelector('#totalPrice');
        const fieldValor = this.form.querySelector('#valor_loja');
        const fieldTotalLoja = this.form.querySelector('#valor_total_mensal');
        const destaqueDataTotalLoja = this.form.querySelector('.destaque-data.totalloja');
        const destaqueDataTotalMensal = this.form.querySelector('.destaque-data.totalmensal');
        const cupomDesconto = this.form.querySelector('#cupom');
    
        if (estabelecimentos === "" || areatotal.value === "0") {
            formadepagamento.value = '';
            formadepagamento.querySelector('option[value="Boleto para cada filial"]').style.display = 'none';
            
            totalPriceStore.innerHTML = "";
            totalPrice.innerHTML = "";
            fieldValor.value = "";
            fieldTotalLoja.value = "";
            // destaqueDataTotalLoja.innerHTML = "";
            // destaqueDataTotalMensal.innerHTML = "";
            cupomDesconto.value = "";
    
            return;
        }
    
        if (estabelecimentos == 1) {
            formadepagamento.value = '';
            formadepagamento.querySelector('option[value="Boleto para cada filial"]').style.display = 'none';
        } else if (estabelecimentos > 1) {
            formadepagamento.querySelector('option[value="Boleto para cada filial"]').style.display = 'block';
        }
    
        if (estabelecimentos >= 1 && estabelecimentos <= 49) {
            this.y = 0;
        } else if (estabelecimentos > 49 && estabelecimentos <= 99) {
            this.y = 1;
        } else if (estabelecimentos > 99 && estabelecimentos <= 499) {
            this.y = 2;
        } else if (estabelecimentos > 499 && estabelecimentos <= 999) {
            this.y = 3;
        } else if (estabelecimentos > 999 && estabelecimentos <= 1999) {
            this.y = 4;
        } else if (estabelecimentos > 1999 && estabelecimentos <= 2999) {
            this.y = 5;
        } else if (estabelecimentos > 2999) {
            this.y = 6;
        }

        if (+areatotal.value != 0) {
            this.x = areatotal.selectedIndex - 1;
        }

        if (this.form.querySelector('#plano_id').value === 1) {
            this.tpr = prcs[this.y][this.x];
        } else {
            this.tpr = prcs2[this.y][this.x];
        }
    
        if (vinhetaExclusiva && vinhetaExclusiva.value === 'sim') {
            this.tpr += 30.00;
        }
    
        if (this.x != -1 && this.y != 7) {
            let tmp = this.tpr * estabelecimentos;
            this.tmp = tmp.toFixed(2).toString().replace('.', ',');
            this.tpr = this.tpr.toFixed(2).toString().replace('.', ',');
            totalPriceStore.innerHTML = this.tpr;
            totalPrice.innerHTML = tmp;
            fieldValor.value = tmp;
            fieldTotalLoja.value = this.tpr;
            // destaqueDataTotalLoja.innerHTML = this.tpr;
            // destaqueDataTotalMensal.innerHTML = tmp;
        }

    }

    todayDate() {

        const objToday = new Date(),
        dayOfMonth = (objToday.getDate() < 10) ? '0' + objToday.getDate() : objToday.getDate(),
        months = new Array('Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'),
        curMonth = months[objToday.getMonth()],
        curYear = objToday.getFullYear();
        const today = dayOfMonth + " de " + curMonth + " de " + curYear;
        
        this.modalTerms.querySelector('.data-atual').innerHTML = today

    }

    controlModalTerms() {

        this.btnOpenModalTerms.addEventListener('click', () => {
            this.modalTerms.classList.add('active')

            this.modalTerms.querySelector('.closeModal').addEventListener('click', () => {
                this.modalTerms.classList.remove('active')
            })
            
            this.modalTerms.querySelector('.btn-continue-termos').addEventListener('click', () => {
                this.modalTerms.classList.remove('active')
            })

        })

    }

    carregaDadosCep() {

        const cepFields = this.form.querySelectorAll('.cepMask');
        cepFields.forEach(fieldCep => {
            fieldCep.addEventListener('blur', async () => {
                console.warn('cep');
                try {
                    const dadosCep = await Forms.checkCep(fieldCep);
                    const counterCep = fieldCep.dataset.counter
                    if(counterCep) {
                        this.form.querySelector('#endereco-'+counterCep).value = dadosCep.logradouro
                        this.form.querySelector('#cidade-'+counterCep).value = dadosCep.localidade
                        this.form.querySelector('#bairro-'+counterCep).value = dadosCep.bairro
                        this.form.querySelector('#estado-'+counterCep).value = dadosCep.uf
                        this.form.querySelector('#numero-'+counterCep).focus()
                    } else {
                        this.form.querySelector('#endereco').value = dadosCep.logradouro
                        this.form.querySelector('#cidade').value = dadosCep.localidade
                        this.form.querySelector('#bairro').value = dadosCep.bairro
                        this.form.querySelector('#estado').value = dadosCep.uf
                        this.form.querySelector('#numero').focus()
                    }
                } catch (error) {
                    console.error("Erro ao carregar dados do CEP:", error);
                    // Trate o erro conforme necessário
                }
            });
        })
    }

    coupon() {

        let validavalor = Number(this.tmp.toString().replace(',', '.'));
        if(validavalor > 0) {
            axios.get('/ajax/cupons.php', {
                params: {
                    cupom: this.form.querySelector('#cupom').value
                }
            })
                .then((response) => {

                    if(response.data.error) {
                        document.querySelector('.cupom-error').innerHTML = response.data.error
                        document.querySelector('.cupom-error').classList.remove('noShow')
                    } else {

                        document.querySelector('.cupom-error').innerHTML = ''
                        document.querySelector('.cupom-error').classList.add('noShow')

                        let original_price = this.tmp.toString().replace(',', '.');
                        let original_price_store = this.tpr.toString().replace(',', '.');
    
                        if (this.form.querySelector('#cupom').value != '' && response != '') {
                            var price = parseFloat(original_price);
                            var price_store = parseFloat(original_price_store);
    
                            price = price - parseFloat(response.data.desconto);
                            price_store = price / parseFloat(this.form.querySelector('#qtde_lojas').value);
    
                            if (price > 0) {
                                var new_tmp = price.toFixed(2).toString().replace('.', ',');
                                var new_tpr = price_store.toFixed(2).toString().replace('.', ',');
    
                                this.form.querySelector('#totalPriceStore').innerHTML = new_tpr;
                                this.form.querySelector('#totalPrice').innerHTML = new_tmp;
                                this.form.querySelector('#valor_loja').value = new_tmp;
                                this.form.querySelector('#valor_total_mensal').value = new_tpr;
                                // this.form.querySelector('.destaque-data.totalloja').innerHTML = new_tpr;
                                // this.form.querySelector('.destaque-data.totalmensal').innerHTML = new_tmp;
                            }
                        } else {
                            this.form.querySelector('#totalPriceStore').innerHTML = this.tpr;
                            this.form.querySelector('#totalPrice').innerHTML = this.tmp;
                            this.form.querySelector('#valor_loja').value = this.tmp;
                            this.form.querySelector('#valor_total_mensal').value = this.tpr;
                            // this.form.querySelector('.destaque-data.totalloja').innerHTML = this.tpr;
                            // this.form.querySelector('.destaque-data.totalmensal').innerHTML = this.tmp;
                        }
                    }
    
                })
                .catch(function (error) {
                    console.log(error);
                })
        } else {
            document.querySelector('.cupom-error').innerHTML = 'Não foi preenchido a quantidade de lojas e metragem para aplicar um cupom.'
            document.querySelector('.cupom-error').classList.remove('noShow')
        }

        
    
    }

    creditCardFields() {
        const creditfields = this.form.querySelector('.credit-card-fields').querySelectorAll('input, select')
        if(this.form.querySelector('#forma_pagamento').value === 'Cartão de crédito') {
            this.form.querySelector('.credit-card-fields').classList.remove('noShow')
            creditfields.forEach(field => {
                field.required = true;
            })
        } else {
            this.form.querySelector('.credit-card-fields').classList.add('noShow')
            creditfields.forEach(field => {
                field.required = false;
            })
        }
    }

    sendForm() {
        // $('.filial').each(function(e){
        //     $(this).find('input, select').each(function(){
        //         name    = $(this).attr('name');
        //         nchars  = (e+1) > 9 ? 4 : 3;
        //         newname = name.substr(0, name.length - nchars);
        //         $(this).attr('name', newname + '['+(e+1)+']');

        //     });
        // });
        
        // data = $(this).find('form').find('#field-ip, #valor_loja, #valor_total_mensal').serialize();
        // data += '&'+$(this).find('form').find(':not(:hidden)').serialize();

        // if($('#plano_id').val()==1){

        //     var destino = 'gera-pedido-hits-novo';

        // }else{

        //     var destino = 'gera-pedido-mensal-novo';

        // }

        // test = String(window.location);
        // pedido_file = (test.indexOf('-qa') >= 0) ? destino+'-qa.php' : destino+'.php';

        // $.ajax({
        //     url: 'https://site.radiosparx.com.br/pedidos/qa366/' + pedido_file,
        //     method: 'post',
        //     data: data,
        //     processData: false,
        //     dataType: 'json',
        //     beforeSend: function( xhr ) {
        //         $('#blockz').remove();
        //         $('body').prepend('<div id="blockz"><div class="loader-containerz"><h5>Isso pode demorar alguns minutos. Por favor, aguarde.</h5> <div id="barsz"><div class="barz"></div><div class="barz"></div><div class="barz"></div><div class="barz"></div><div class="barz"></div><div class="barz"></div><div class="barz"></div><div class="barz"></div><div class="barz"></div><div class="barz"></div></div></div></div>');
        //         $('#blockz').css('display', 'flex');
        //     },
        //     error: function (error) {
        //         /*window.location.href = "https://www.radiosparx.com.br/site/parabens-radiosparx/";*/
        //     },

        // }).done(function(data) {
        //     if (data.success) {
        //         //window.location.href = "https://site.radiosparx.com.br/parabens-radiosparx/";
        //     }
        //     //window.location.href = "https://site.radiosparx.com.br/parabens-radiosparx/";
        // });
    }

    templateFiliais(i) {
        let template = `
            <div class="filial">
                <div class="card marginFieldSet">
                    <div class="card-body">
                        <legend>Dados da Filial ${i}</legend>
                        
                        <div class="form-group">
                            <label for="razao_social[]">Razão Social</label>
                            <input type="text" name="razao_social[]" id="razao_social-${i}" class="form-control" required>
                        </div>

                        <div class="form-group">
                            <label for="nome_fantasia[]">Nome Fantasia</label>
                            <input type="text" name="nome_fantasia[]" id="nome_fantasia-${i}" class="form-control" required>
                        </div>

                        <div class="row">
                            <div class="col-lg-6 col-12">
                                <div class="form-group">
                                    <label for="cnpj[]">CNPJ</label>
                                    <input type="text" name="cnpj[]" id="cnpj-${i}" class="form-control" required>
                                </div>
                            </div>
                            <div class="col-lg-6 col-12">
                                <div class="form-group">
                                    <label for="cep">CEP</label>
                                    <input type="text" name="cep[]" id="cep-${i}" class="form-control cepMask" data-counter="${i}" required>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-8 col-12">
                                <div class="form-group">
                                    <label for="endereco[]">Endereço</label>
                                    <input type="text" name="endereco[]" id="endereco-${i}" class="form-control" required>
                                </div>
                            </div>
                            <div class="col-lg-4 col-12">
                                <div class="form-group">
                                    <label for="numero[]">Número</label>
                                    <input type="text" name="numero[]" id="numero-${i}" class="form-control" required>
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="complemento[]">Complemento</label>
                            <input type="text" name="complemento[]" id="complemento-${i}" class="form-control" required>
                        </div>

                        <div class="row">
                            <div class="col-lg-4 col-12">
                                <div class="form-group">
                                    <label for="estado[]">Estado</label>
                                    <select name="estado[]" id="estado-${i}" class="form-control" required>
                                        <option value="0" selected disabled>Selecione</option>
                                        <option value="AC">Acre</option>
                                        <option value="AL">Alagoas</option>
                                        <option value="AP">Amapá</option>
                                        <option value="AM">Amazonas</option>
                                        <option value="BA">Bahia</option>
                                        <option value="CE">Ceará</option>
                                        <option value="DF">Distrito Federal</option>
                                        <option value="ES">Espírito Santo</option>
                                        <option value="GO">Goiás</option>
                                        <option value="MA">Maranhão</option>
                                        <option value="MT">Mato Grosso</option>
                                        <option value="MS">Mato Grosso do Sul</option>
                                        <option value="MG">Minas Gerais</option>
                                        <option value="PA">Pará</option>
                                        <option value="PB">Paraíba</option>
                                        <option value="PR">Paraná</option>
                                        <option value="PE">Pernambuco</option>
                                        <option value="PI">Piauí</option>
                                        <option value="RJ">Rio de Janeiro</option>
                                        <option value="RN">Rio Grande do Norte</option>
                                        <option value="RS">Rio Grande do Sul</option>
                                        <option value="RO">Rondônia</option>
                                        <option value="RR">Roraima</option>
                                        <option value="SC">Santa Catarina</option>
                                        <option value="SP">São Paulo</option>
                                        <option value="SE">Sergipe</option>
                                        <option value="TO">Tocantins</option>
                                        <option value="EX">Estrangeiro</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-lg-4 col-12">
                                <div class="form-group">
                                    <label for="cidade[]">Cidade</label>
                                    <input type="text" name="cidade[]" id="cidade-${i}" class="form-control" required>
                                </div>
                            </div>
                            <div class="col-lg-4 col-12">
                                <div class="form-group">
                                    <label for="bairro[]">Bairro</label>
                                    <input type="text" name="bairro[]" id="bairro-${i}" class="form-control" required>
                                </div>
                            </div>
                        </div>

                        <legend>Dados do responsável</legend>

                        <div class="form-group">
                            <label for="responsavel_nome[]">Responsável</label>
                            <input type="text" name="responsavel_nome[]" id="responsavel_nome-${i}" class="form-control" required>
                        </div>

                        <div class="row">
                            <div class="col-lg-6 col-12">
                                <div class="form-group">
                                    <label for="responsavel_cpf[]">CPF do Responsável</label>
                                    <input type="text" name="responsavel_cpf[]" id="responsavel_cpf-${i}" class="form-control cpfMask" required>
                                </div>
                            </div>
                            <div class="col-lg-6 col-12">
                                <div class="form-group">
                                    <label for="responsavel_nascimento[]">Data de nascimento</label>
                                    <input type="date" name="responsavel_nascimento[]" id="responsavel_nascimento-${i}" class="form-control dateMask" required>
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="responsavel_email[]">E-mail do responsável</label>
                            <input type="email" name="responsavel_email[]" id="responsavel_email-${i}" class="form-control" required>
                        </div>

                        <div class="row">
                            <div class="col-lg-6 col-12">
                                <div class="form-group">
                                    <label for="responsavel_telefone[]">Telefone Fixo</label>
                                    <input type="tel" name="responsavel_telefone[]" id="responsavel_telefone-${i}" class="form-control telMask" required>
                                </div>
                            </div>
                            <div class="col-lg-6 col-12">
                                <div class="form-group">
                                    <label for="responsavel_celular[]">Telefone Celular</label>
                                    <input type="tel" name="responsavel_celular[]" id="responsavel_celular-${i}" class="form-control telMask" required>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
        return template
    }

}